import {
  DotSeparatedList,
  Input,
  Text,
  Title,
  type UseModalState,
} from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { FormControl, InputLabel, Stack } from "@mui/material";
// eslint-disable-next-line no-restricted-imports -- legacy, use @clipboard-health/date-time. See https://www.notion.so/BP-Date-Time-2ef8643321f48032ad80e8a5b30aa278 for more information
import { format } from "date-fns";
import { useHistory } from "react-router-dom";

import { DigitalClockInputBottomSheet } from "../../DateTime/DigitalClockInputBottomSheet";
import { useInHomeVisitModalsDataContext } from "../../ShiftDiscovery/useInHomeVisitModalsDataContext";
import { BOOKED_VISIT_LOG_START_TIME_MODAL_PATH } from "../paths";

interface LogVisitEndTimeBottomSheetProps {
  modalState: UseModalState;
  visitDate: Date;
  startAt: Date;
  onConfirm: (date: Date) => void;
}

export function LogVisitEndTimeBottomSheet(props: LogVisitEndTimeBottomSheetProps) {
  const { modalState, visitDate, startAt, onConfirm } = props;
  const { visit, generateModalPath } = useInHomeVisitModalsDataContext();
  const history = useHistory();

  const detailTexts = [`Started ${format(startAt, "h:mm a")}`, format(visitDate, "EEE, MMM d")];

  return (
    <DigitalClockInputBottomSheet
      modalState={modalState}
      initialTime={startAt}
      minutesStep={1}
      title={
        <Title component="h5" variant="h5">
          Log a visit
        </Title>
      }
      subtitle={
        <Title semibold variant="h3" component="h3">
          Select end time
        </Title>
      }
      onConfirm={onConfirm}
      onBack={() => {
        if (!isDefined(visit)) {
          return;
        }

        history.replace(
          generateModalPath(BOOKED_VISIT_LOG_START_TIME_MODAL_PATH, {
            caseId: visit.attributes.caseId,
            visitId: visit.id,
          })
        );
      }}
    >
      <FormControl fullWidth>
        <Stack spacing={4}>
          <InputLabel>Visit Date</InputLabel>
          <Input
            disabled
            size="large"
            iconType="calendar-with-cells"
            label="Visit Date"
            value={visitDate.toLocaleDateString()}
          />
          <DotSeparatedList>
            {detailTexts.map((text) => (
              <Text key={text} variant="body2">
                {text}
              </Text>
            ))}
          </DotSeparatedList>
        </Stack>
      </FormControl>
    </DigitalClockInputBottomSheet>
  );
}
